import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.674 5.423a1.094 1.094 0 0 0-1.535 0 1.05 1.05 0 0 0 0 1.499 1.094 1.094 0 0 0 1.535 0 1.05 1.05 0 0 0 0-1.5m-2.52-.995a2.494 2.494 0 0 1 3.505 0 2.45 2.45 0 0 1 0 3.489 2.494 2.494 0 0 1-3.504 0 2.45 2.45 0 0 1 0-3.49M11.194 5.6a.583.583 0 1 0-.824.824.583.583 0 0 0 .824-.824M9.38 4.61a1.983 1.983 0 1 1 2.804 2.804A1.983 1.983 0 0 1 9.379 4.61m.014 4.394a.7.7 0 0 1 .7-.7h1.924c1.095 0 1.983.888 1.983 1.983a.7.7 0 1 1-1.4 0 .583.583 0 0 0-.583-.583h-1.924a.7.7 0 0 1-.7-.7m-5.268 1.467a.72.72 0 0 0-.725.711v.41a.7.7 0 1 1-1.4 0v-.41c0-1.172.958-2.11 2.125-2.11h3.563c1.167 0 2.125.938 2.125 2.11v.41a.7.7 0 1 1-1.4 0v-.41a.72.72 0 0 0-.725-.71z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=UserGroupIcon16.js.map